<template>
  <div>
    <router-link to="/upgrade/pricing" class="cursor-pointer" @click.native="handleBannerClick">
      <AlertBanner :status="1" class="banner-below-nav h-40 !leading-10" :fullPageBanner="true">
        <ContentfulText
          contentType="landingPageBanner"
          fieldName="promo_banner_post_login_sc_web"
          fallback="Save up to 60% with our value plans"
        />
      </AlertBanner>
    </router-link>
    <!-- adds a spacer to push down main content since the banner is position: fixed -->
    <div class="h-52 md-1:h-56 w-full lg:hidden">&nbsp;</div>
  </div>
</template>

<script lang="ts">
import AlertBanner from '../alert_banner/AlertBanner.vue';
import ContentfulText from '../contentful_text/ContentfulText.vue';
import { sendSegmentEvent } from '../../lib/segment';

export default {
  name: 'ContentfulUpgradeBanner',
  components: {
    AlertBanner,
    ContentfulText,
  },
  props: {
    segmentEventName: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleBannerClick() {
      sendSegmentEvent(this.$props.segmentEventName, {});
    },
  },
};
</script>
